import React from "react";
import styled from "styled-components/macro";
import SearchBar from "../SearchBar";

export const TopHeaderMenu = styled.div`
  flex-flow: row nowrap;
  justify-content: flex-start;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0px;
  margin-bottom: 0px;
  ${(props) => (props.isLanguageListOpen ? "margin-top:0px" : "")}
`;

export const TopNavBar = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
  justify-content: flex-end;
  flex: 1;
  & a {
    color: var(--sv-color-dark-green);
    font-family: var(--sv-font-sans);
    font-weight: 500;
    padding: 11px 0px;
    text-align: center;
    margin-left: 8px;
    font-size: 16px;
  }
  & a:hover {
    color: var(--sv-color-hyperlink-teal);
  }
`;

export const TopNavigation = styled.div`
  display: flex;

  justify-content: end;
  align-items: center;
  ${(props) => (props.isLanguageListOpen ? "padding:0px;" : "")}

  > a {
    color: var(--sv-color-dark-green);
    font-family: var(--sv-font-sans);
    font-weight: 500;
    padding: 11px 0px;
    text-align: center;
    white-space: nowrap;
    text-decoration: auto;
  }
  > a:hover {
    color: var(--sv-color-hyperlink-teal);
  }
`;

export const TopLogo = styled.img`
  display: inline-block;
  margin-top: 0.5rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
  height: 40px;
  max-height: 40px;
`;

export const HeaderSearchBar = styled(SearchBar)`
  min-width: 477px;
  width: 61%;
  margin-right: 20px;
`;

export const TopHeaderNav = styled.ul`
  flex-direction: row;
  margin-left: auto;
  display: flex;
  padding-left: 0;

  list-style: none;

  box-sizing: border-box;
  align-items: center;
  width: 100%;
  > a {
    white-space: nowrap;
  }
`;

export const HeaderMenu = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 0 !important;
  border-top: none;
  border-bottom: none;
  position: relative;
  justify-content: flex-start;
  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 100vw;
    height: 1px;
    background: var(--sv-color-dark-gray);
    transform: translateX(-50%);
  }
  & .primary-nav-item {
    font-family: var(--sv-font-sans);
    font-weight: 700;
    color: var(--sv-color-dark-green);
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0;
    text-transform: none;
    border: none;
    background: transparent;
    cursor: pointer;
    text-decoration: none;
    border-bottom: 2px solid transparent;
    height: 48px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0;
    ${(props) =>
      props.fullwidth
        ? "margin: 0 24px;"
        : "margin-left: 18px; margin-right: 24px;"}
  }
  & .primary-nav-item:hover {
    color: var(--sv-color-dark-green) !important;
    border-bottom-color: transparent;
  }
  & .primary-nav-item.headerMenuActive {
    font-weight: 700;
  }
  & .primary-nav-item img {
    vertical-align: middle;
    height: 16px;
    width: 16px;
    margin-left: 6px;
    color: inherit;
  }
`;
